import { render, staticRenderFns } from "./organizationClinics.vue?vue&type=template&id=00507fe6&scoped=true&"
import script from "./organizationClinics.vue?vue&type=script&lang=js&"
export * from "./organizationClinics.vue?vue&type=script&lang=js&"
import style0 from "./organizationClinics.vue?vue&type=style&index=0&id=00507fe6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00507fe6",
  null
  
)

export default component.exports